<template>
  <div style="display:flex;" class="main">
    <el-col :span="4">
      <el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
        :default-openeds="openeds" router>
        <div v-for="item in menus" :key="item.route" >
          <el-menu-item style="display:flex; align-items: center;" :index="item.route" :key="item.route" v-if="!item.children">
            <i :class="item.icon"></i>{{item.name}}
          </el-menu-item>
          <el-submenu :index="item.route" :key="item.route" v-if="item.children">
            <template slot="title"><i :class="item.icon"></i>{{item.name}}</template>
            <el-menu-item :index="item1.route" v-for="item1 in item.children" 
              :key="item1.route">
              {{item1.name}}
            </el-menu-item>
          </el-submenu>
        </div>
      </el-menu>
    </el-col>

    <router-view></router-view>

  </div>
</template>

<script>
export default {
  data() {
    return {
      menus: [
        {
          route: "/PersonalCenter/index",
          name: "个人中心",
          children: false,
          icon: 'el-icon-s-home',
        },
        {
          route: "/PersonalCenter/article",
          name: "发布",
          icon:'el-icon-s-promotion',
          children: [
            { route: "/PersonalCenter/Patent", name: "专利" },
            { route: "/PersonalCenter/ResearchReport", name: "研报" },
            { route: "/PersonalCenter/ReleaseInformation", name: "资讯" },
          ],
        },
        {
          route: "/PersonalCenter/conSend",
          name: "发布管理",
          icon: "el-icon-document",
          children: [
            { route: "/PersonalCenter/Releases", name: "我的发布" },
            { route: "/PersonalCenter/CommentsManage", name: "评论管理" },
            { route: "/PersonalCenter/conPerson", name: "粉丝管理" },
          ],
        },

        {
          route: "/PersonalCenter/dataAny",
          name: "数据",
          icon: "el-icon-pie-chart",
          children: [
            { route: "/PersonalCenter/DataAnalysis", name: "数据分析" },
            { route: "/PersonalCenter/DataAny", name: "指数分析" },
            { route: "/PersonalCenter/DataAnyFen", name: "粉丝分析" },
          ],
        },

        {
          route: "/PersonalCenter/myVip",
          name: "设置",
          icon: "el-icon-setting",
          children: [
            { route: "/PersonalCenter/AccountSeetings", name: "账号设置" },
            // { route: "/PersonalCenter/myVip", name: "我的权益" },
            { route: "/PersonalCenter/Dds", name: "账号信用" },
            { route: "/PersonalCenter/ResetPwd", name: "修改密码" },
          ],
        },
      ],
      openeds: [
        "/PersonalCenter/article",
        "/PersonalCenter/conSend",
        "/PersonalCenter/dataAny",
        "/PersonalCenter/myVip",
      ],
    };
  },
  methods: {
    handleOpen(key, keyPath) {
      //////console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      //////console.log(key, keyPath);
    },
  },
};
</script>

<style scoped>
.main {
  width: 1200px;
  margin: 20px auto 80px;
}
>>> .el-col{
  margin-right:20px;
}
>>> .el-menu-vertical-demo {
  text-align: center;
}
>>> .el-col {
  float: none !important;
}
.el-menu{
  border:none;
}
>>> .el-menu-item:focus,
.el-menu-item:hover {
  background: #1f72d9;
  color: #fff;
}
.el-menu-item:hover .hover_img{
  background: #fff;
  border-radius:50%;
}

>>> .el-submenu__title{
  display: flex;
    align-items: center;
}
.el-submenu__title i{
  color:#446FDE;
}
</style>